// extracted by mini-css-extract-plugin
export default {"label":"StatusBadge_label_jBQ9q","icon":"StatusBadge_icon_zZSBt"};